<script>
    /**
     * Alert
     */
    export default {
        name: 'modal-footer',
        props: {},
        methods: {},
        mounted () {}
    };
</script>

<template>
    <div class="normal-modal__ft">
        <slot></slot>
    </div>
</template>

<style lang="less" scoped>
</style>
